module.exports = __webpack_public_path__ + "img/windLocal.2af0a025.png";